export const DEFAULT_LOCALE = 'en' as const;

export const SUPPORTED_LOCALES = [
  'en',
  'de',
  'fr',
  'it',
  'es',
  'pl',
  'sv',
  'nl',
  'pt',
  'el',
  'fi',
  'da',
  'hu',
  'cs',
  'sk',
  'sl',
  'et',
  'lv',
  'lt',
  'hr',
  'ro',
  'bg',
  'sw',
  'zh',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const RTL_LOCALES: SupportedLocale[] = [];

export const OG_LOCALE_MAP: Record<SupportedLocale, string> = {
  en: 'en_US',
  de: 'de_DE',
  fr: 'fr_FR',
  it: 'it_IT',
  es: 'es_ES',
  pl: 'pl_PL',
  sv: 'sv_SE',
  nl: 'nl_NL',
  pt: 'pt_PT',
  el: 'el_GR',
  fi: 'fi_FI',
  da: 'da_DK',
  hu: 'hu_HU',
  cs: 'cs_CZ',
  sk: 'sk_SK',
  sl: 'sl_SI',
  et: 'et_EE',
  lv: 'lv_LV',
  lt: 'lt_LT',
  hr: 'hr_HR',
  ro: 'ro_RO',
  bg: 'bg_BG',
  sw: 'sw_KE',
  zh: 'zh_CN',
};

export function isSupportedLocale(value?: string | null): value is SupportedLocale {
  return !!value && SUPPORTED_LOCALES.includes(value as SupportedLocale);
}

export function normalizeLocale(value?: string | null): SupportedLocale {
  if (isSupportedLocale(value)) return value;
  return DEFAULT_LOCALE;
}

export function isRtlLocale(locale: SupportedLocale): boolean {
  return RTL_LOCALES.includes(locale);
}
